<form [formGroup]="queryForm">
  <div class="row">
    <div class="col-1 space-h-l">
      <mat-form-field class="form-field-l">
        <mat-label>{{ (selectDomain.value ? 'DOMAIN' : 'SELECT_DOMAIN') | translate }}</mat-label>
        <mat-select id="RecipesSearchDomainBtn" formControlName="domain" #selectDomain>
          <div id="RecipesSearchDomainLst">
            <mat-option [value]="null"></mat-option>
            <mat-option [value]="noDomain" *ngIf="isBrandSelected()">{{ noDomain.key | translate }}</mat-option>
            <mat-optgroup *ngFor="let ssid of getDomainsSSID()" [label]="ssid">
              <mat-option *ngFor="let selection of filteredDomains[ssid] | sortBy : 'translatedName' : 'ASC'" [value]="selection">
                {{ selection.translatedName }}
              </mat-option>
            </mat-optgroup>
          </div>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-1 space-h-l">
      <mat-form-field class="form-field-l">
        <mat-label>{{ (selectMarket.value ? 'MARKET' : 'SELECT_MARKET') | translate }}</mat-label>
        <mat-select id="RecipesSearchMarketBtn" formControlName="market" [compareWith]="compareByKey" #selectMarket>
          <div id="RecipesSearchMarketLst">
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let selection of filteredMarkets | sortBy : 'translatedName' : 'ASC'" [value]="selection">
              {{ selection.translatedName }}
            </mat-option>
          </div>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-1 space-h-l">
      <mat-form-field class="form-field-l">
        <mat-label>{{ (selectLang.value ? 'LANGUAGE' : 'SELECT_LANGUAGE') | translate }}</mat-label>
        <mat-select id="RecipesSearchLangBtn" formControlName="lang" #selectLang>
          <div id="RecipesSearchLangLst">
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let selection of filteredLanguages | sortBy : 'translatedName' : 'ASC'" [value]="selection">
              {{ selection.translatedName }}
            </mat-option>
          </div>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-1 space-h-l">
      <mat-form-field class="form-field-l">
        <mat-label>{{ (selectBrand.value ? 'BRAND' : 'SELECT_BRAND') | translate }}</mat-label>
        <mat-select id="RecipesSearchBrandBtn" formControlName="brand" #selectBrand>
          <div id="RecipesSearchBrandLst">
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let selection of brands | sortBy : 'translatedName' : 'ASC'" [value]="selection">
              {{ selection.translatedName }}
            </mat-option>
          </div>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <app-recipe-search-bar class="search-bar" [fieldFilters]="fieldFilters" (searchBarChange)="searchAcp($event)"></app-recipe-search-bar>
  <app-recipe-headband
    *ngIf="!isPopup && queryForm.controls.domain.value"
    [queryForm]="queryForm"
    [languages]="languages"
    [statuses]="statuses"
    [filteredData]="{filteredMarkets, filteredLanguages}"
  ></app-recipe-headband>
  <app-facet-chips
    [scope]="'recipe'"
    [facetFilters]="facetFilters"
    [fieldFilters]="fieldFilters"
    (allFiltersRemoved)="removeFacetFilters()"
    (filterRemoved)="removeFacetFilter($event)"
  ></app-facet-chips>
</form>
